export const paths = {
  NEW: 'new',
  EDIT: 'edit',
  VIEW: 'view',
}

export const addressBookLinks = {
  addAddressBookLink: () => `/${paths.NEW}`,
  editAddressBookLink: (params: { addressId: string }) => `/${paths.EDIT}/${params.addressId}`,
}

export type AddressBookLinks = typeof addressBookLinks
